import { render } from "./water-payment-summary.vue?vue&type=template&id=85a78a26"
import script from "./water-payment-summary.vue?vue&type=script&lang=js"
export * from "./water-payment-summary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__